import { render } from "./DocumentViewPage.vue?vue&type=template&id=582e29fa&scoped=true"
import script from "./DocumentViewPage.vue?vue&type=script&lang=js"
export * from "./DocumentViewPage.vue?vue&type=script&lang=js"

import "./DocumentViewPage.vue?vue&type=style&index=0&id=582e29fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582e29fa"]])

export default __exports__